// Rótulos e cores do cardápio pela IA (zaper-api/CARDAPIO_IA_PLAN.md).

const STATUS = {
    processando: { texto: 'Montando', cor: 'blue' },
    concluido: { texto: 'Concluído', cor: 'green' },
    falhou: { texto: 'Falhou', cor: 'red' },
    desfeito: { texto: 'Desfeito', cor: 'grey' },
    rascunho: { texto: 'Rascunho', cor: 'grey' },
};

const ETAPAS = {
    preparando: 'abrindo arquivos',
    lendo: 'lendo o cardápio',
    estruturando: 'montando o plano',
    conferindo: 'conferindo',
    cadastrando: 'cadastrando',
};

const AVISOS = {
    sem_preco: 'Sem preço',
    ilegivel: 'Ilegível',
    duvida: 'Dúvida',
    promocao: 'Promoção',
    fora_do_escopo: 'Fora do cardápio',
    outro: 'Ficou de fora',
};

const MATERIAIS = {
    imagem: { texto: 'Foto', icone: 'mdi-image-outline' },
    pdf: { texto: 'PDF', icone: 'mdi-file-pdf-box' },
    docx: { texto: 'Documento', icone: 'mdi-file-word-outline' },
    xlsx: { texto: 'Planilha', icone: 'mdi-file-excel-outline' },
    arquivo_texto: { texto: 'Arquivo de texto', icone: 'mdi-file-document-outline' },
    link: { texto: 'Link', icone: 'mdi-link-variant' },
    texto: { texto: 'Texto', icone: 'mdi-text' },
};

export const status = s => STATUS[s] || { texto: s, cor: 'grey' };
export const etapa = e => ETAPAS[e] || e;
export const aviso = t => AVISOS[t] || t;
export const material = t => MATERIAIS[t] || { texto: t, icone: 'mdi-file-outline' };

export const usd = v => `US$ ${(+v || 0).toFixed(v >= 1 ? 2 : 3).replace('.', ',')}`;

export function resumo(r) {
    if (!r || r.produtos === undefined) {
        return '';
    }

    const partes = [`${r.produtos} produtos`];
    r.etapas && partes.push(`${r.etapas} etapas`);
    r.combos && partes.push(`${r.combos} combos`);
    r.pausados && partes.push(`${r.pausados} pausados`);

    return partes.join(' · ');
}

// O que o acompanhamento mostra embaixo da coluna "Criação" (setup_info da loja).
export function seloAcompanhamento(setupInfo) {
    const estado = (setupInfo && setupInfo.cardapio_ia) || null;
    const origem = setupInfo && setupInfo.cardapio_origem;

    if (!estado) {
        return null;
    }

    if (origem === 'ia' && estado.status === 'concluido') {
        return { texto: 'Cardápio pela IA', cor: 'blue', icone: 'mdi-creation-outline' };
    }

    if (estado.status === 'processando') {
        return { texto: 'IA montando', cor: 'grey', icone: 'mdi-progress-clock' };
    }

    if (estado.status === 'equipe') {
        return { texto: 'IA não montou: equipe', cor: 'orange', icone: 'mdi-account-wrench-outline' };
    }

    if (estado.status === 'falhou') {
        return { texto: `IA falhou (${estado.tentativas || 1}x)`, cor: 'red', icone: 'mdi-alert-circle-outline' };
    }

    return null;
}
